import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { getFileIcon, showToast } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { Copy, CopyPlus, CopyPlusIcon, ScanSearch } from "lucide-react";
import React, { useMemo } from "react";
import { Link } from "react-router";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar"

const ColumnList = ({ refetch }: { refetch?: () => void }) => {
  const BucketEndpoint = useMemo(() => endpoint["uploadimage"], []);
  const { clearSelection } = useSelectionStore();
  console.log("Success", BucketEndpoint);
  const { handleAction } = useHandleAction({
    endpoint: BucketEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Modal Name",
        cell: (row: any) => {
          return (
           <Tooltip description={row?.model_name}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {row?.model_name}
                </span>
              </div>
            </Tooltip>
          );
        },
        sortable: true,
      },
      {
        name: "Object ID",
        cell: (row: any) => {
          return (
            // <div className="flex items-start  gap-2 justify-start w-full h-full">
            //   <div className="max-w-[240px] w-fit truncate">
            //     {row?.object_id}
            //   </div>
            // </div>
            <Tooltip description={row?.object_id}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {row?.object_id}
                </span>
              </div>
            </Tooltip>
          );
        },
        sortable: true,
      },
      {
        name: "User Action",
        cell: (row: any) => {
          return (
            // <div className="flex items-start  gap-2 justify-start w-full h-full">
            //   <div className="max-w-[240px] w-fit truncate">
            //     {row?.action} {row?.model_name}
            //   </div>
            // </div>
            <Tooltip description={`${row?.action} ${row?.model_name}`}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {`${row?.action} ${row?.model_name}`}
                </span>
              </div>
            </Tooltip>
          );
        },
        sortable: true,
      },
      {
        name: "Performed By",
        cell: (row: any) => {
          return (<div className="flex items-center gap-4 w-full h-full">
            {row?.performed_by ? (
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                <Avatar className="rounded-lg">
                  <AvatarImage
                    src={row?.performed_by?.professional_image || NoImage}
                    alt={row?.performed_by?.username || "ER"}
                  />
                  <AvatarFallback>DP</AvatarFallback>
                </Avatar>
                |
                <Tooltip
                  description={
                    row?.performed_by?.username
                  }
                >
                  <span className="truncate max-w-[150px] w-fit">
                    {row?.performed_by?.username}
                  </span>
                </Tooltip>
                </div>

                <Tooltip
                  description={
                     row?.performed_by?.email
                  }
                >
                  <span className="truncate max-w-[150px] w-fit">
                    { row?.performed_by?.email}
                  </span>
                </Tooltip>
              </div>
            ) : (
              "N/A"
            )}
          </div>)
        },
        sortable: true,
      },
      {
        name: "View Details",
        cell: (row: any) => {
          const handleCopy = (data:string) => {
            let url = "";
            switch (data) {
              case "student":
                url = `${window.location.origin}/students?page=edit&page-item=${row?.object_id}`;
               break;
              case "course":
                url = `${window.location.origin}/courses?page=edit&page-item=${row?.object_id}`;
                break;
              case "blog":
                url = `${window.location.origin}/add-blogs?page=edit&page-item=${row?.object_id}`;
                break;
              case "career":
                url = `${window.location.origin}/careers?page=edit&page-item=${row?.object_id}`;
                break;
              case "forms":
                url = `${window.location.origin}/forms?page=edit&page-item=${row?.object_id}`;
                break;
              default:
                url = "#";
                break;
            }

            return url;
          }
          return (
            <div className="flex items-start  gap-2 justify-start w-full h-full">
              {row.action !=="deleted" ? <div className="max-w-[240px] w-fit truncate">
                <Link
                  to={handleCopy(row?.model_name)}
                  className="text-blue-600 hover:underline flex items-center gap-1"
                >
                  View Details <ScanSearch className="w-4 h-4" />
                </Link>
              </div> : "--"}
            </div>
          );
        },
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

export { ColumnList };
